import { Link } from 'react-router-dom';
import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';
import { DEF_BY_NO } from '@/canvas/defs/index';
import { canvasLabel } from '@/components/canvas/bits';

// What the learner should know before typing: a stale review, a locked canvas, or earlier canvases still open.
export default function CanvasNotices({ state, behind, next, confirming, confirmedOn, onReaffirm, onReopen }) {
  return (
    <>
        {state.confirmed && state.stale && (
          <div className="flex flex-col gap-3 rounded-2xl border border-warning-border bg-warning-muted p-4 sm:flex-row sm:items-center" role="alert">
            <ApperIcon name="TriangleAlert" size={22} className="shrink-0 text-warning" />
            <div className="flex-1 space-y-0.5 text-sm">
              <p className="font-semibold">An earlier canvas changed after you confirmed this one</p>
              <p>Check the pulled-in values below. If this canvas still holds, confirm it again. If not, reopen it and change it.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button size="sm" onClick={onReaffirm} disabled={confirming || !state.canConfirm}>
                Confirm again
              </Button>
              <Button size="sm" variant="outline" onClick={onReopen}>
                Reopen to edit
              </Button>
            </div>
          </div>
        )}

        {state.confirmed && !state.stale && (
          <div className="flex flex-col gap-3 rounded-2xl border border-success-border bg-success-muted p-4 sm:flex-row sm:items-center">
            <ApperIcon name="CircleCheck" size={22} className="shrink-0 text-success" />
            <div className="flex-1 space-y-0.5 text-sm">
              <p className="font-semibold">Confirmed{confirmedOn ? ` on ${confirmedOn}` : ''}</p>
              <p>This canvas is locked and feeds the canvases after it. Reopen it if you need to change anything.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {next && (
                <Button size="sm" asChild>
                  <Link to={`/canvas/${next.no}`}>
                    Next: {canvasLabel(next)} <ApperIcon name="ArrowRight" size={14} />
                  </Link>
                </Button>
              )}
              <Button size="sm" variant="outline" onClick={onReopen}>
                <ApperIcon name="LockOpen" size={14} /> Reopen to edit
              </Button>
            </div>
          </div>
        )}

        {behind.length > 0 && (
          <div className="flex gap-3 rounded-2xl border border-primary/30 bg-accent/70 p-4 text-sm">
            <ApperIcon name="Info" size={18} className="mt-0.5 shrink-0 text-primary" />
            <div className="space-y-1">
              <p>
                This canvas pulls from{' '}
                {behind.map((n, i) => (
                  <span key={n}>
                    <Link to={`/canvas/${n}`} className="font-semibold text-primary underline underline-offset-2">
                      {canvasLabel(DEF_BY_NO[n])}
                    </Link>
                    {i < behind.length - 2 ? ', ' : i === behind.length - 2 ? ' and ' : ''}
                  </span>
                ))}
                , which {behind.length === 1 ? 'is' : 'are'} not confirmed yet.
              </p>
              <p className="text-muted-foreground">You can carry on. What is pulled in updates when those change, and this canvas will ask you to review it.</p>
            </div>
          </div>
        )}
    </>
  );
}
